import { useAuth } from "@mindlercare/auth-ui";
import { Outlet } from "react-router-dom";
import { styled } from "styled-components";
import Dialog from "components/dialogs";
import { Drawer } from "components/drawer";
import { Header } from "../components/header";
import { LoadingView } from "../views/LoadingView";
import { useAppConfig } from "api/config";
import { AlertProvider } from "components/booking/AlertContext";

export const Layout = () => {
  const { isLoggedIn } = useAuth();
  const { isLoading: isLoadingConfig } = useAppConfig();

  return (
    // AlertProvider wraps Layout because <Dialog> (sibling of <Outlet>) hosts slot dialog components that consume useAlertContext
    <AlertProvider>
      <div style={{ display: "flex", height: "100%" }}>
        {isLoggedIn && <Drawer />}
        <Header />
        <Dialog />
        <Container $isLoggedIn={isLoggedIn}>
          {isLoadingConfig ? <LoadingView /> : <Outlet />}
        </Container>
      </div>
    </AlertProvider>
  );
};

type ContainerProps = {
  readonly $isLoggedIn: boolean;
};

const Container = styled.div<ContainerProps>`
  height: 100%;
  width: 100%;
  padding: ${(props) => (props.$isLoggedIn ? "64px 0 0 0" : "0")};
  overflow: scroll;
  background-color: white;
`;
